import React, { useEffect, useState } from 'react';
import { DialogTitle, DialogContent, DialogActions } from '../Dialog/Dialog';
import {
    Dialog,
    makeStyles,
    InputAdornment,
    FormHelperText,
    Grid,
    Button
} from "@material-ui/core";
import * as logger from "../../../logger";
import { connect } from 'react-redux';
import { addNewDriver, getDieselCardDriverList, editDriver } from "../../../store/actions/vehicleActionCreator";
import { Form } from 'react-final-form';
import { TextField } from 'mui-rff';
import { checkNumberOnly } from "../../../utils/utils";

const useStyles = makeStyles((theme) => ({

    brV1: {
        borderRadius: 8
    },
    dialogContent: {
        backgroundColor: '#f6f6f8 '
    },
    saveCta: {
        backgroundColor: '#09101e',
        borderRadius: '4px',
        color: 'white',
        textTransform: 'none',
        fontSize: 14,
        boxShadow: 'none !important',
        "&:hover": {
            backgroundColor: '#09101e'
        }
    },
    disableCta: {
        backgroundColor: '#dadada',
        fontSize: 14,
        color: '#5e636c',
        borderRadius: 4,
        textTransform: 'none',
        boxShadow: 'none !important',
        "&: hover": {
            backgroundColor: '#dadada'
        }
    },
    titleV1: {
        color: 'rgba(11, 19, 35, 0.75)',
        marginBottom: 4,
        fontWeight: 600
    },
    mt24: {
        marginTop: 24
    },
    helperText: {
        marginTop: 4,
        color: 'rgba(11, 19, 35, 0.75)',
        fontSize: 12,
        fontWeight: 300
    },
    textFieldV1: {
        "& .MuiOutlinedInput-root": {
            backgroundColor: 'white !important'
        }
    }

}))

const AddEditNewDriver = ({ open, onClose, onConfirm, dispatchAddNewDriver, dispatchGetDieselCardDriverList, driverFlowValue, verifyDriverInfo, dispatchEditDriver }) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [driverNameValue, setDriverNameValue] = useState("");
    const [driverNumberValue, setDriverNumberValue] = useState("");
    const [confirmDisabled, setConfirmDisabled] = useState(false);

    const initialValues = {
        driverName: driverNameValue,
        driverNumber: driverNumberValue
    }

    useEffect(() => {

        if (verifyDriverInfo) {
            if (driverFlowValue == "add") {

                setDriverNameValue(verifyDriverInfo)

                let driverInfoArray = verifyDriverInfo.split(" ");

                if (driverInfoArray && driverInfoArray.length > 0) {
                    setDriverNameValue(driverInfoArray[0])

                    if (checkNumberOnly(driverInfoArray[driverInfoArray.length - 1])) {
                        setDriverNumberValue(driverInfoArray[driverInfoArray.length - 1])
                    }
                }

            } else if (driverFlowValue == "verify") {

                if ("name" in verifyDriverInfo) {
                    setDriverNameValue(verifyDriverInfo.name)
                }

                if ("contactNumber" in verifyDriverInfo) {
                    setDriverNumberValue(verifyDriverInfo.contactNumber)
                }
            }
        }

    }, [driverFlowValue]);

    const classes = useStyles();

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const getFormFields = values => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div>
                            <div className={classes.titleV1}>Driver Name*</div>
                            <TextField
                                placeholder='Enter Driver Name'
                                name="driverName"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setDriverNameValue(e.target.value)}
                                required={true}
                                fieldProps={{
                                    parse: value => value && (value.trim()).length == 0 ? value.trim() : value
                                }}
                                classes={{ root: classes.textFieldV1 }}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mt24}>
                            <div className={classes.titleV1}>Driver Mobile Number*</div>
                            <TextField
                                placeholder='Enter Driver Mobile Number*'
                                name="driverNumber"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setDriverNumberValue(e.target.value)}
                                required={true}
                                fieldProps={{
                                    parse: value => value ? (value.replace(/(\d{5})(\d{5})/, "$1-$2")).trim() : ""
                                }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">+91</InputAdornment>
                                }}
                                classes={{ root: classes.textFieldV1 }}
                            />
                            <FormHelperText className={classes.helperText}>OTP will come to this phone number before filling fuel</FormHelperText>
                        </div>
                    </>
                )
            }
        ]
    }

    const validate = values => {
        const errors = {};

        let number = values.driverNumber ? /^[5-9]{1}[0-9]{9}$/.test(values.driverNumber.replace("-", "")) : "";

        if (!values.driverName) {
            errors.driverName = "Enter Driver Name."
        }

        if (!values.driverNumber || !number) {
            errors.driverNumber = "Enter Valid Driver Mobile Number."
        }

        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }

        return errors;
    }

    const onSubmit = values => {

        if (!confirmDisabled) {
            let driverNameArray = values.driverName.split(" ");
            let driverNameCapitalize = [];
            let driverId = verifyDriverInfo && verifyDriverInfo.id ? verifyDriverInfo.id : "";

            if (driverNameArray && driverNameArray.length > 0) {
                driverNameArray.forEach((value) => {
                    if (value) {
                        driverNameCapitalize.push((value.charAt(0).toUpperCase()) + value.slice(1));
                    }
                })
            }

            const newDriverRequest = {
                name: driverNameCapitalize && driverNameCapitalize.length > 0 ? (driverNameCapitalize.join(" ")).trim() : "",
                contactNumber: values.driverNumber ? values.driverNumber.replace("-", "") : null,
            }

            if (driverFlowValue == "verify") {

                dispatchEditDriver(driverId, newDriverRequest,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Add Edit New Driver", "Edit Driver Successfull")
                            dispatchGetDieselCardDriverList(
                                (responseData) => {
                                    if (responseData && responseData.status && responseData.status.code == 200) {
                                        logger.log("Driver Deatils Dialog", "Get Diesel Card Drivers List Successfull");
                                        onConfirm(data.response)
                                    }
                                },
                                () => {
                                    logger.log("Driver Deatils Dialog", "Get Diesel Card Drivers List Failed");
                                }
                            )
                        }
                    },
                    () => {
                        logger.log("Add Edit New Driver", "Edit Driver Failed")
                    }
                )

            } else if (driverFlowValue == "add") {
                dispatchAddNewDriver(newDriverRequest,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Add New Driver", "New Driver added Successfully")
                            dispatchGetDieselCardDriverList(
                                (responseData) => {
                                    if (responseData && responseData.status && responseData.status.code == 200) {
                                        logger.log("Driver Deatils Dialog", "Get Diesel Card Drivers List Successfull");
                                        onConfirm(data.response)
                                    }
                                },
                                () => {
                                    logger.log("Driver Deatils Dialog", "Get Diesel Card Drivers List Failed");
                                }
                            )
                        }
                    },
                    () => {
                        logger.log("Add New Driver", "New Driver added Failed")
                    }
                )
            }
        }

    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={dialogOpen}
                classes={{ paperScrollPaper: classes.brV1 }}
            >
                <DialogTitle id="add-new-driver-detail-title" onClose={handleClose}>
                    {driverFlowValue == "add" &&
                        <>
                            New Driver Details
                        </>
                    }
                    {driverFlowValue == "verify" &&
                        <>
                            Verfiy Driver Details
                        </>
                    }
                </DialogTitle>

                <DialogContent dividers className={classes.dialogContent}>

                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />

                </DialogContent>

                <DialogActions>
                    <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
                        Close
                    </Button>
                    <Button className={confirmDisabled ? classes.disableCta : classes.saveCta} type="submit" variant="contained"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>

            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchAddNewDriver: (data, onSuccess, onFailure) => dispatch(addNewDriver(data, onSuccess, onFailure)),
    dispatchGetDieselCardDriverList: (onSuccess, onError) => {
        dispatch(getDieselCardDriverList(onSuccess, onError))
    },
    dispatchEditDriver: (data, onSuccess, onError) => {
        dispatch(editDriver(data, onSuccess, onError))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(AddEditNewDriver)
